import { render, staticRenderFns } from "./microDetails.vue?vue&type=template&id=3f3a063a&scoped=true"
import script from "./microDetails.vue?vue&type=script&lang=js"
export * from "./microDetails.vue?vue&type=script&lang=js"
import style0 from "./microDetails.vue?vue&type=style&index=0&id=3f3a063a&prod&lang=scss&scoped=true"
import style1 from "./microDetails.vue?vue&type=style&index=1&id=3f3a063a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3a063a",
  null
  
)

export default component.exports